import { render } from "./ActiveRegionsView.vue?vue&type=template&id=3181925b&scoped=true"
import script from "./ActiveRegionsView.vue?vue&type=script&lang=js"
export * from "./ActiveRegionsView.vue?vue&type=script&lang=js"

import "./ActiveRegionsView.vue?vue&type=style&index=0&id=3181925b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3181925b"]])

export default __exports__